import { WorkItemStatus } from './WorkItemStatus.enum';

export const nonEditableStatuses = [
  WorkItemStatus.ARCHIVED,
  WorkItemStatus.BILLED,
  WorkItemStatus.ACCEPTED,
];
